import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { companyInfo } from '../mock';

const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => setIsOpen(!isOpen);

  const menuItems = [
    { path: '/', label: 'Hjem' },
    { path: '/om', label: 'Om Fryd!' },
    { path: '/projekter', label: 'Projekter' },
    { path: '/kontakt', label: 'Kontakt' }
  ];

  return (
    <>
      {/* Menu Button - Fixed in top left corner */}
      <button
        onClick={toggleMenu}
        className="fixed top-8 left-8 z-50 p-3 bg-neutral-50 backdrop-blur-sm rounded-full shadow-lg hover:bg-neutral-100 transition-all duration-300 hover:scale-110"
        aria-label="Menu"
      >
        {isOpen ? (
          <X className="w-6 h-6 text-gray-900" />
        ) : (
          <Menu className="w-6 h-6 text-gray-900" />
        )}
      </button>

      {/* Full Screen Overlay Menu */}
      <div
        className={`fixed inset-0 bg-black/95 backdrop-blur-md z-40 transition-all duration-500 ${
          isOpen ? 'opacity-100 visible' : 'opacity-0 invisible'
        }`}
      >
        <div className="flex flex-col items-center justify-center h-full">
          {/* Company Name */}
          <div className="mb-16">
            <h2 className="text-[#f5f1e8] text-5xl md:text-7xl font-light tracking-wide">
              {companyInfo.name}
            </h2>
          </div>

          {/* Menu Items */}
          <nav className="flex flex-col items-center space-y-8">
            {menuItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                onClick={toggleMenu}
                className={`text-3xl md:text-5xl font-light tracking-wide transition-all duration-300 ${
                  location.pathname === item.path
                    ? 'text-[#f5f1e8]'
                    : 'text-[#f5f1e8]/60 hover:text-[#f5f1e8]'
                }`}
              >
                {item.label}
              </Link>
            ))}
          </nav>

          {/* Tagline */}
          <div className="absolute bottom-12 text-center px-8">
            <p className="text-[#f5f1e8]/70 text-sm md:text-base max-w-2xl">
              {companyInfo.tagline}
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Navigation;
